<ng-container *ngIf="name!==undefined">
	<div mat-dialog-title>
		<span class="save-view-block-info" translate>datacenter.save-changes-in-the-view</span>
		<button type="button" mat-icon-button class="exit-button-icon" [disableRipple]="true" (click)="onCancelClick()" [mat-dialog-close]="undefined">
			<mat-icon svgIcon="md:close"></mat-icon>
		</button>
	</div>
	<div mat-dialog-actions>
		<button [mat-dialog-close]="data.name" [disabled]="name===undefined" cdkFocusInitial class="save-view-button" type="button" mat-button>
			<span class="save-view-button-name" translate>datacenter.save</span>
			<mat-icon iconPositionEnd class="save-view-button-icon" svgIcon="save_disk"></mat-icon>
		</button>
	</div>

	<div mat-dialog-content>
		<div class="save-view-block-row save-view-block-row-no-margin save-view-block-row-bottom-margin">
			<span class="save-view-block-info" translate>datacenter.or-save-as-a-new-view</span>
		</div>
		<div class="save-view-block-row save-view-block-row-no-margin save-view-block-right-margin">
			<mat-form-field class="input-max-width">
				<input matInput [maxLength]="63" [formControl]="newName" [placeholder]="'datacenter.view-name' | translate">
				<mat-error *ngIf="newName.hasError('required')" translate>datacenter.view-name.error</mat-error>
				<mat-error *ngIf="newName.hasError('duplicateName')">
					{{ 'datacenter.view-name.duplicate.error' | translate:{ viewName: newName.value } }}
				</mat-error>
			</mat-form-field>
		</div>
	</div>
	<div mat-dialog-actions>
		<button [disabled]="newName.invalid" [mat-dialog-close]="newName.value" class="save-view-button"
				type="button" mat-button>
			<span class="save-view-button-name" translate>datacenter.save-the-view</span>
			<mat-icon iconPositionEnd class="save-view-button-icon" svgIcon="save_disk"></mat-icon>
		</button>
	</div>
</ng-container>

<ng-container *ngIf="name===undefined">
	<div mat-dialog-title>
		<span class="save-view-block-info" translate>datacenter.save-new-view</span>
		<button class="exit-button-icon" (click)="onCancelClick()" [mat-dialog-close]="undefined" type="button" mat-icon-button>
			<mat-icon svgIcon="md:close"></mat-icon>
		</button>
	</div>
	<div mat-dialog-content>
		<mat-form-field class="input-max-width">
			<input matInput [maxLength]="63" [formControl]="newName" [placeholder]="'datacenter.view-name' | translate">
			<mat-error *ngIf="newName.hasError('required')" translate>datacenter.view-name.error</mat-error>
			<mat-error *ngIf="newName.hasError('duplicateName')">
				{{ 'datacenter.view-name.duplicate.error' | translate:{ viewName: newName.value } }}
			</mat-error>
		</mat-form-field>
	</div>
	<div mat-dialog-actions>
		<button [disabled]="newName.invalid" [mat-dialog-close]="newName.value" class="save-view-button"
				type="button" mat-button>
			<span class="save-view-button-name" translate>datacenter.save</span>
			<mat-icon iconPositionEnd class="save-view-button-icon" svgIcon="save_disk"></mat-icon>
		</button>
	</div>
</ng-container>
